import LegalLayout from "@/pages/LegalLayout";

export default function CookiesPage() {
  return (
    <LegalLayout title="Cookies & úložisko" lastUpdated="9. február 2026">
      <p className="lead">
        Aplikácia <strong>Real Selfie</strong> nepoužíva žiadne sledovacie ani
        marketingové cookies. Používame iba lokálne úložisko prehliadača na
        funkčné účely.
      </p>

      <h2>🍪 Cookies</h2>
      <p>
        <strong>Nepoužívame žiadne HTTP cookies.</strong> Žiadne sledovanie
        tretími stranami, žiadny Google Analytics, žiadny Facebook Pixel.
      </p>

      <h2>💾 Lokálne úložisko (localStorage)</h2>
      <p>
        Aplikácia ukladá nasledujúce hodnoty výhradne vo vašom prehliadači
        (nikam ich neposiela na server okrem prípadov uvedených nižšie):
      </p>
      <table>
        <thead>
          <tr>
            <th>Kľúč</th>
            <th>Účel</th>
            <th>Odoslané na server</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>rs_device_id</code>
            </td>
            <td>Anonymný UUID identifikátor zariadenia pre paywall</td>
            <td>Áno — pri kontrole Premium statusu</td>
          </tr>
          <tr>
            <td>
              <code>rs_autosave</code>
            </td>
            <td>Stav prepínača automatického ukladania (on/off)</td>
            <td>Nie</td>
          </tr>
          <tr>
            <td>
              <code>rs_autoshare</code>
            </td>
            <td>Stav prepínača auto-zdieľania (on/off)</td>
            <td>Nie</td>
          </tr>
          <tr>
            <td>
              <code>rs_hint_seen</code>
            </td>
            <td>Či ste videli úvodný banner &bdquo;Kde sú moje fotky?&ldquo;</td>
            <td>Nie</td>
          </tr>
        </tbody>
      </table>

      <h2>📦 IndexedDB</h2>
      <p>
        Aplikácia využíva IndexedDB (lokálnu databázu v prehliadači) na
        ukladanie:
      </p>
      <ul>
        <li>
          <strong>Vašich fotografií</strong> — celá galéria zostáva výhradne
          vo vašom zariadení. Žiadna fotka neopustí prehliadač.
        </li>
        <li>
          <strong>Odkazu (handle) na zvolený priečinok</strong> — ak ste
          povolili funkciu auto-uloženia do priečinka RealSelfie cez File
          System Access API (Chrome/Edge).
        </li>
      </ul>

      <h2>🔧 Service Worker (PWA cache)</h2>
      <p>
        Aplikácia má service worker, ktorý cachuje statické súbory (HTML, JS,
        CSS, ikony) pre offline použitie a rýchlejšie načítanie. Cache je
        čisto lokálna, neobsahuje žiadne osobné údaje.
      </p>

      <h2>Ako vymazať uložené dáta</h2>
      <p>
        V nastaveniach prehliadača môžete kedykoľvek vymazať dáta stránky
        realselfie.eu. Pozor: tým prídete o:
      </p>
      <ul>
        <li>Vašu galériu fotiek (IndexedDB)</li>
        <li>Premium licenciu naviazanú na device_id (môžete o ňu prísť)</li>
        <li>Všetky nastavenia aplikácie</li>
      </ul>
      <p>
        Ak prídete o Premium licenciu vymazaním dát, kontaktujte{" "}
        <a href="mailto:support@realselfie.eu">support@realselfie.eu</a> —
        pomôžeme s obnovou na základe payment ID zo Stripe potvrdenia.
      </p>

      <h2>Súhlas</h2>
      <p>
        Keďže nepoužívame sledovacie cookies a localStorage je nevyhnutný pre
        funkčnosť aplikácie, nevyžaduje sa od vás osobitný cookie consent
        banner podľa ePrivacy Direktívy.
      </p>
    </LegalLayout>
  );
}
